import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="bg-gray-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-magenta-500 mb-8 text-center">Our Story</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div className="space-y-6">
            <p className="text-gray-300 text-xl font-semibold">
              We're entrepreneurs just like you.
            </p>
            
            <p className="text-gray-300">
              We understand the struggle of balancing quality and affordability when it comes to branded apparel because we've been there ourselves.
            </p>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <p className="text-gray-300">
                It all started with the necessity of providing our BMW repair shop employees with branded work attire. Like many small businesses, we faced the challenge of navigating minimum order requirements, leaving us with excess garments we couldn't utilize.
              </p>
            </div>
          </div>
          
          <div className="relative h-96 rounded-lg overflow-hidden ring-1 ring-magenta-500/50">
            <img 
              src="https://stackblitz.com/storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBemlLRkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--7150d14498ff234051342971a41256e7a7e5b92e/hoodieabout.JPG"
              alt="Custom printing process"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="relative h-64 rounded-lg overflow-hidden ring-1 ring-cyan-500/50">
            <img 
              src="https://stackblitz.com/storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBK3VKRkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--5e2e0963672e4336b7f10bbc60e9f1a4845fd43b/hoodie3.jpg"
              alt="Custom hoodie"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
          <div className="relative h-64 rounded-lg overflow-hidden ring-1 ring-magenta-500/50">
            <img 
              src="https://stackblitz.com/storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBemVLRkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--b21ba50960900cc3fea03f3eafe28b6650eab4ea/hatabout.jpg"
              alt="Custom hat"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-64 rounded-lg overflow-hidden ring-1 ring-cyan-500/50">
            <img 
              src="https://stackblitz.com/storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBK3FKRkE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--69f12c2fddd91b0495d64483f9e4b016a712989f/shirt5.jpg"
              alt="Custom t-shirt"
              className="absolute inset-0 w-full h-full object-cover object-bottom"
            />
          </div>
        </div>
        
        <div className="prose prose-lg prose-invert mx-auto space-y-8">
          <p className="text-gray-300">
            Through relentless testing and investment in top-notch equipment, we finally achieved our goal – an impressive line of merchandise that not only meets but exceeds expectations.
          </p>
          
          <div className="bg-gray-800 p-6 rounded-lg">
            <h3 className="text-xl font-bold text-magenta-500 mb-4">What Sets Us Apart</h3>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>No minimum orders</li>
              <li>No hidden fees or charges</li>
              <li>Nearly free consultation</li>
              <li>Drop shipping services</li>
              <li>Premium quality materials</li>
              <li>Expert craftsmanship</li>
            </ul>
          </div>
          
          <p className="text-gray-300">
            Our customers no longer purchase our apparel out of sheer support; they buy it because it's genuinely excellent. From comfortable fits to long-lasting durability, our products become their go-to favorites.
          </p>
          
          <div className="text-center">
            <p className="text-xl font-bold text-cyan-500">
              Partner with Highline Apparel today, and let's embark on a journey of success together.
            </p>
            <Link
              to="/start-project"
              className="inline-block mt-6 px-8 py-3 border border-transparent text-base font-medium rounded-md text-black bg-magenta-500 hover:bg-magenta-400 transition-colors"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}